import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Modal from "components/common/Modal";
import { getArchiveRequest } from "store/swList/swListActions";
import useSelector from "store/useSelector";

interface IArchiveBulkModal {
    onClose: (value: boolean) => void,
}

const ArchiveBulkModal: React.FC<IArchiveBulkModal> = (props) => {
    const dispatch = useDispatch();
    const [reason, setReason] = useState<string>("");
    const {
        swListForZip: {
            swListZip,
        },
    } = useSelector(store => store.swList);

    return (
        <Modal
            header="Archive Standard Works"
            controls={(
                <>
                    <button
                        className="primary-button"
                        onClick={() => {
                            dispatch(getArchiveRequest(
                                {
                                    swListZip,
                                    reason,
                                }
                            ));
                            props.onClose(false);
                        }}
                    >
                        Archive
                    </button>
                    <button
                        className="secondary-button"
                        onClick={() => props.onClose(false)}
                    >
                        Cancel
                    </button>
                </>
            )}
            isOpen={true}
        >{swListZip.length == 1 ? (<>
            <p>
                <strong>Are you sure you want to archive this standard work?</strong>
                <br />
                <br />
                This will archive all versions of the standard work in the system.
                The standard work will be removed from the website and it will no longer be able to be updated.
            </p>
            <p>
                <strong>
                    Reason for archiving the standard work
                </strong>
            </p>
            <textarea
                onChange={(e) => setReason(e.target.value)}
                value={reason}
            />
        </>) : (<><p>
            <strong>Are you sure you want to archive these standard works?</strong>
            <br />
            <br />
            This will archive all versions of the standard works in the system.
            The standard works will be removed from the website and they will no longer be able to be updated.
        </p>
            <p>
                <strong>
                    Reason for archiving the standard works
                </strong>
            </p>
            <textarea
                onChange={(e) => setReason(e.target.value)}
                value={reason}
            /></>)}

        </Modal>
    );
};

export default ArchiveBulkModal;